<template>
  <section class="section section_bg first_page">
    <div class="container-flud ">
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="col-md-12 center-block loading_div " v-if="is_load==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div class="col-md-12 center-block loading_div " v-if="is_error==true">
        <h2>{{ error_message}}</h2>
      </div>

      <div class="col-12 " v-if="is_load==true">
      <div class="second_section">
        <h2 v-if="available.length>0">Создание заявки на вывод</h2>
        <table class="table" v-if="available.length>0">
          <tr>
            <td><select class="form-control" @change="changeCurrency" v-model="newRequest.currency">
              <option selected disabled="disabled">Выберите сумму</option>
              <option v-for="(current_available,available_index) in available" :key="available_index" :value="current_available.currency">{{ current_available.sum }} {{ current_available.currency }}</option>
            </select></td>
          </tr>
          <tr v-if="final_sum && newRequest.currency">
            <td><p>Комиссия при выводе {{ config.percent}}%</p></td>
          </tr>
          <tr v-if="final_sum && newRequest.currency">
            <td><p>Вы получите  {{ final_sum }} {{ newRequest.currency}}</p></td>
          </tr>
          <tr v-if="final_sum && newRequest.currency">
            <td>
              <button class="btn" @click="sendRequest()">Вывести</button>
            </td>
          </tr>
        </table>
        <h4>Список заявок на вывод</h4>
        <div class="row second_section" v-for="(current_row,row_index) in rows" :key="row_index">
          <div class="col-md-4 col-12">
            {{ current_row.created_at}}
          </div>
          <div class="col-6 col-md-4 "><span class="badge badge-info">{{ current_row.final_sum }} {{ current_row.currency}}</span></div>
          <div class="col-6 col-md-4">
            <span class="badge badge-danger" v-if="current_row.is_complete==0">в процессе</span>
            <span class="badge badge-success" v-if="current_row.is_complete==1">выведено</span>
          </div>
        </div>
      </div>
        <div class="row col-12  second_section d-flex align-items-center justify-content-center" v-if="total>offset">
          <div class="row second_section d-flex justify-content-center">
            <button class="btn" @click="firstLoading">Загрузить еще</button>

          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "Withdrawal.vue",
  data() {
    return {
      'is_load':false,
      'is_error':false,
      'limit':10,
      'offset':0,
      'total':0,
      'error_message':'',
      'config':{},
      'available':[],
      'newRequest':{
        'currency':'',
      },
      'final_sum':null,
      'rows':[],

    }
  },
  methods: {
    sendRequest(){

      var app=this;
      var current_currency=app.newRequest.currency;
      var post_data={
        "currency":current_currency
      }

      app.is_load=false;
      Api.createWithdrawalRequest(post_data,function(data){
        app.is_load=false;
        app.is_error=false;
        app.rows=[];
        app.offset=0;
        app.firstLoading();
      },function(err){

        app.is_load=true;
        app.is_error=true;
        app.error_message=err.response.data.message;
      });
    },
    changeCurrency(){
      var app=this;
      var current_currency=app.newRequest.currency;
      app.available.forEach(function(elem){

        if(elem.currency==current_currency){
          var percent=elem.sum / 100 * app.config.percent;
          var final_sum=elem.sum - percent;
          app.final_sum=final_sum;
        }
      });


    },
    firstLoading(){
      var app=this;
      Api.loadWithdrawal(app.limit,app.offset,function(data){
        app.is_error=false;
        app.is_load=true;
        app.available=data.available;
        app.config=data.config;
        app.rows=app.rows.concat(data.rows);
        app.offset=data.offset;
        app.total=data.total;
      },function(error){


        app.is_error=true;
        app.error_message=error.response.data.message;
      })
    }
  },
  mounted() {
   this.firstLoading();


  },
  components: {LoadingBlock}
}
</script>

<style scoped>

</style>